import { getCampaigns } from '../claimer/utils';
import { CampaignResult, normalizeAddress } from '../claimer/types';

export const calculateTotalRewards = (address: string | undefined): number => {
  if (!address) {
    throw new Error('Address parameter is required');
  }

  let totalRewards = 0;

  getCampaigns().forEach((campaign: CampaignResult) => {
    const participant = campaign.participants_with_proofs?.find(
      (entry) => entry.participant === normalizeAddress(address),
    );
    if (participant) {
      // Convert string to number for display
      totalRewards += parseInt(participant.amount);
    }
  });

  return totalRewards;
};

export const formatRewardsDisplay = (unitsAmount: number): string => {
  if (0 < unitsAmount && unitsAmount < 0.1) {
    // For small amounts, use toFixed(18) then remove trailing zeros
    const fixedString = unitsAmount.toFixed(18);
    // Remove trailing zeros after the decimal point
    return fixedString.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') + ' VLR';
  }

  return `${unitsAmount.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })} VLR`;
};

export const getTotalRewardsFormatted = (address: string | undefined): string => {
  const total = calculateTotalRewards(address);
  return formatRewardsDisplay(total);
};

export const getAllRewardsTotal = (): number => {
  let totalRewards = 0;

  getCampaigns().forEach((campaign: CampaignResult) => {
    campaign.participants_with_proofs?.forEach((participant) => {
      // Convert string to number for display
      totalRewards += parseInt(participant.amount);
    });
  });

  return totalRewards;
};

export const getAllRewardsTotalFormatted = (): string => {
  const total = getAllRewardsTotal();
  return formatRewardsDisplay(total);
};

export const isAddressEligible = (address: string | undefined): boolean => {
  if (!address) return false;

  // Check if address exists in any campaign data
  return getCampaigns().some((campaign: CampaignResult) =>
    campaign.participants_with_proofs?.some(
      (participant) => participant.participant === normalizeAddress(address),
    ),
  );
};
